// Calm transition band: three pulsing dots, each emitting an expanding ripple.
const DOTS = [
  { color: '#FDE47A', shadow: 'rgba(247,203,45,0.7)', delay: '0s' },
  { color: '#7fa8ff', shadow: 'rgba(127,168,255,0.8)', delay: '1.3s' },
  { color: '#6ed7a6', shadow: 'rgba(110,215,166,0.8)', delay: '2.6s' },
];

export const Separator3 = () => (
  <div className={styles.band} aria-hidden="true">
    {DOTS.map((dot) => (
      <span
        key={dot.color}
        className={styles.dot}
        style={{
          color: dot.color,
          background: dot.color,
          boxShadow: `0 0 10px ${dot.shadow}`,
          animationDelay: dot.delay,
        }}
      >
        <span className={styles.ripple} style={{ animationDelay: dot.delay }} />
      </span>
    ))}
  </div>
);

const styles = {
  band: 'flex h-[150px] items-center justify-center gap-10 marketing-dark:bg-mf-navy',
  dot: 'relative h-[7px] w-[7px] rounded-full motion-safe:animate-sep-pulse',
  ripple:
    'absolute -inset-[6px] rounded-full border-[1.5px] border-current opacity-0 motion-safe:animate-sep-ripple',
};
